import { HttpErrorResponse } from '@angular/common/http';
import { Component,EventEmitter, HostListener, Input,OnInit, Output} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductFavoriteRequest, ProductFavoriteResponse} from 'src/app/models/product-favorite.model';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { UserSaved } from 'src/app/models/user.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { ProductFavoriteService } from 'src/app/services/product-favorite.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';

@Component({
    selector: 'app-modal-create-product-favorite',
    templateUrl: './modal-create-product-favorite.component.html',
    styleUrls: ['./modal-create-product-favorite.component.scss']
})
export class ModalCreateProductFavoriteComponent implements OnInit {
    @HostListener('document:keydown.escape')
    onEscapePressed() {

        if (this.saving) {
            return;
        }

        this.closeModal();
    }

    @Input()
    product: ProductResponse;

    @Output()
    close = new EventEmitter<boolean>();

    user: UserSaved = null;
    warehouses: WarehouseResponse[] = [];
    favoriteWarehouses: WarehouseResponse[] = [];
    availableWarehouses: WarehouseResponse[] = [];
    selectedWarehouses: number[] = [];

    loading = false;
    saving = false;

    constructor(
        private toastService: ToastrService,
        private productFavoriteService: ProductFavoriteService,
        private warehouseService: WarehouseService,
        private authService: AuthenticationService
    ) {
        this.user = this.authService.getUser();
        console.log("Entro a crear producto favorito modal");
    }

    ngOnInit(): void {
        console.log("El producto es aaa:", this.product);
        if (!this.product) {
            console.log("entro a cerrar");
            this.close.emit(false);
            return;
        }

        this.loadWarehouses();
    }

    /**
     * Primero obtenemos las bodegas disponibles
     * para el usuario.
     */
    loadWarehouses() {

        this.loading = true;

        this.warehouseService
            .getWarehousesAllowedByUser(this.user.id)
            .subscribe({
                next: (response: ResponseObject) => {

                    if (response.data.length > 0) {

                        this.warehouses = response.data;

                        this.getFavorites();

                    } else {

                        this.getAllWarehouses();
                    }
                },
                error: (error: HttpErrorResponse) => {

                    this.loading = false;

                    this.toastService.error(
                        error.error.message
                    );
                }
            });
    }

    /**
     * Si el usuario no tiene bodegas específicamente
     * asignadas, obtenemos las bodegas de la empresa.
     */
    getAllWarehouses() {

        this.warehouseService
            .getWarehouseByClue('')
            .subscribe({
                next: (response: ResponseObject) => {

                    this.warehouses = response.data;

                    this.getFavorites();
                },
                error: (error: HttpErrorResponse) => {

                    this.loading = false;

                    this.toastService.error(
                        error.error.message
                    );
                }
            });
    }

    /**
     * Obtiene las bodegas donde el producto
     * ya se encuentra marcado como favorito.
     */
    getFavorites() {

        this.productFavoriteService
            .getByProduct(this.product.id)
            .subscribe({
                next: (response: ResponseObject) => {

                    const favorites =
                        response.data as ProductFavoriteResponse[];

                    this.favoriteWarehouses =
                        favorites
                            .filter(f => f.warehouse != null)
                            .map(f => f.warehouse);

                    this.updateAvailableWarehouses();

                    this.loading = false;
                },
                error: (error: HttpErrorResponse) => {

                    this.loading = false;

                    this.toastService.error(
                        error.error.message ||
                        "Error al obtener las bodegas favoritas"
                    );
                }
            });
    }

    updateAvailableWarehouses() {

        const favoriteIds = new Set(
            this.favoriteWarehouses.map(w => w.id)
        );

        this.availableWarehouses =
            this.warehouses.filter(
                w => !favoriteIds.has(w.id)
            );

        /*
        * Quitamos de la selección cualquier bodega
        * que ya no esté disponible.
        */
        const availableIds = new Set(
            this.availableWarehouses.map(w => w.id)
        );

        this.selectedWarehouses =
            this.selectedWarehouses.filter(
                id => availableIds.has(id)
            );
    }

    saveFavorite() {
        if (this.saving) {
            return;
        }

        if (this.selectedWarehouses.length === 0) {

            this.toastService.info(
                "Selecciona al menos una bodega"
            );

            return;
        }

        const requests: ProductFavoriteRequest[] =
            this.selectedWarehouses.map(warehouseId => {

                const request =
                    new ProductFavoriteRequest();

                request.productId =
                    this.product.id;

                request.warehouseId =
                    warehouseId;

                return request;
            });

        this.saving = true;

        this.productFavoriteService
            .createMultiple(requests)
            .subscribe({
                next: () => {

                    this.saving = false;

                    const amount =
                        this.selectedWarehouses.length;

                    this.toastService.success(
                        amount === 1
                            ? "Producto agregado a favoritos correctamente"
                            : `Producto agregado a favoritos en ${amount} bodegas correctamente`
                    );

                    /*
                    * Limpiamos la selección antes
                    * de volver a cargar.
                    */
                    this.selectedWarehouses = [];

                    /*
                    * Actualizamos favoritos y bodegas
                    * disponibles sin cerrar el modal.
                    */
                    this.getFavorites();
                },
                error: (error: HttpErrorResponse) => {

                    this.saving = false;

                    this.toastService.error(
                        error.error?.message ||
                        "Error al guardar los productos favoritos"
                    );
                }
            });
    }

    closeModal() {
        this.close.emit(false);
    }

    isWarehouseSelected(warehouseId: number): boolean {
        return this.selectedWarehouses.includes(warehouseId);
    }

    toggleWarehouse(warehouseId: number) {
        const index = this.selectedWarehouses.indexOf(warehouseId);

        if (index >= 0) {
            this.selectedWarehouses.splice(index, 1);
        } else {
            this.selectedWarehouses.push(warehouseId);
        }
    }

    selectAllWarehouses() {
        this.selectedWarehouses =
            this.availableWarehouses.map(w => w.id);
    }

    clearSelectedWarehouses() {
        this.selectedWarehouses = [];
    }

    areAllWarehousesSelected(): boolean {
        return this.availableWarehouses.length > 0 &&
            this.selectedWarehouses.length === this.availableWarehouses.length;
    }
}